import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoPermission } from '../models/projeto-permission.model';

@Injectable({
  providedIn: 'root',
})

export class PermissionProjectService extends BaseService<ProjetoPermission>{

  constructor(public http: HttpClient) {
    super(http)
  }

  public getPermission(id:number): Observable<ProjetoPermission> {
    return this.http.get<ProjetoPermission>(this.baseUrl + '/'+id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/permission';
  }

}
